import { useTranslation } from "react-i18next";
import ameelio from "../ameelio.svg";
import SuccessScreen from "../lib/SuccessScreen";

// Landing page after an Ameelio staff Ory logout. /login/ameelio launches
// Google SSO immediately, which can silently sign the user back in, so they
// land here and choose when to log back in.
export default function AmeelioLoggedOutScreen() {
  const { t } = useTranslation();

  return (
    <SuccessScreen
      illustration={ameelio}
      illustrationWidth={200}
      title={t("You have been logged out")}
      content={t("Log back in to continue using the Ameelio toolbox.")}
      buttonText={t("Log in")}
      buttonPath="/login/ameelio"
    />
  );
}
